import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { workspaceApi } from '../api/workspaceApi';

const SIDEBAR_COUNTS_POLL_MS = 15 * 60 * 1000;

export function useSidebarCounts(locationId: number | null | undefined) {
  return useQuery({
    queryKey: keys.workspace.sidebar(locationId ?? 0),
    queryFn: ({ signal }) => workspaceApi.getSidebarCounts(locationId!, { signal }),
    enabled: locationId != null,
    staleTime: SIDEBAR_COUNTS_POLL_MS,
    refetchInterval: SIDEBAR_COUNTS_POLL_MS,
    refetchOnWindowFocus: false,
  });
}
